<div class="header">
  <div class="title">Export Gantt Chart</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="ganttPdfExportForm">
  <!-- Subject -->
  <mat-form-field class="flex-auto gt-xs:pr-3">
    <mat-label>Paper Size:</mat-label>
    <mat-select [formControlName]="'paper_size'">
      <mat-option *ngFor="let paperSize of paperSizes" [value]="paperSize.slug">
        {{ paperSize.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="w-full">
    <mat-label>Page Orientation:</mat-label>
    <mat-select [formControlName]="'page_orientation'">
      <mat-option *ngFor="let pageOrientation of pageOrientations" [value]="pageOrientation">
        {{ pageOrientation }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="w-full">
    <mat-label>Fit To Width</mat-label><br />
    <mat-radio-group formControlName="fit_to_width">
      <mat-radio-button value="yes" class="mr-1">Yes</mat-radio-button>
      <mat-radio-button value="no">No</mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="actions justify-end">
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button class="send-button" mat-flat-button [color]="'primary'" DebounceClick (debounceClick)="save()">
        <span>OK</span>
      </button>
    </div>
  </div>
</form>
